/**
 * Billing feature keys that must never be shown in enterprise platform usage
 * UI surfaces. Add keys here to hide them from the enterprise report hook.
 * The org listing shows database_optimization — only the enterprise hook uses
 * this filter.
 */
export const HIDDEN_PLATFORM_USAGE_FEATURE_KEYS = [
  'database_optimization',
] as const;

/**
 * Returns a shallow-copied report with `features` filtered to exclude items
 * whose `feature` key matches any entry in HIDDEN_PLATFORM_USAGE_FEATURE_KEYS.
 * Applied only to the enterprise platform usage report hook; the org listing
 * shows database_optimization and does not call this filter.
 */
export const filterHiddenPlatformUsageFeatures = <
  T extends { features?: Array<{ feature?: string }> }
>(
  report: T
): T => {
  if (!report.features) {
    return report;
  }
  return {
    ...report,
    features: report.features.filter(
      (f) =>
        !HIDDEN_PLATFORM_USAGE_FEATURE_KEYS.includes(
          f.feature as (typeof HIDDEN_PLATFORM_USAGE_FEATURE_KEYS)[number]
        )
    ),
  };
};
